// Page scroll lock, reference counted so overlapping overlays cannot unlock the
// page while another is still open, and so the scroll position survives the
// position:fixed swap that iOS Safari needs.
//
// One counter for every overlay that locks the page, because two are worse than
// none: each snapshots the body separately, so a dialog opened from inside the
// Clients sheet would capture the body while the sheet's lock was applied, and
// releasing the sheet first - crossing above its collapse point - then closing
// the dialog would restore the locked styles with nobody left to clear them.
// `modal_dialog_hook.js` imports these rather than keeping its own copy.
let scrollLockCount = 0
let scrollLockState = null

export const lockPageScroll = () => {
  scrollLockCount += 1
  if (scrollLockCount > 1) return

  const body = document.body
  const html = document.documentElement

  scrollLockState = {
    x: window.scrollX,
    y: window.scrollY,
    body: {
      left: body.style.left,
      overflow: body.style.overflow,
      position: body.style.position,
      right: body.style.right,
      top: body.style.top,
      width: body.style.width,
    },
    htmlOverflow: html.style.overflow,
  }

  html.style.overflow = "hidden"
  body.style.position = "fixed"
  body.style.top = `-${scrollLockState.y}px`
  body.style.left = `-${scrollLockState.x}px`
  body.style.right = "0"
  body.style.width = "100%"
  body.style.overflow = "hidden"
}

export const unlockPageScroll = () => {
  scrollLockCount = Math.max(0, scrollLockCount - 1)
  if (scrollLockCount > 0 || !scrollLockState) return

  const body = document.body
  const html = document.documentElement
  const state = scrollLockState

  html.style.overflow = state.htmlOverflow
  Object.assign(body.style, state.body)
  scrollLockState = null
  window.scrollTo(state.x, state.y)
}
